import React, { useEffect, useState } from 'react';
import Select, { SingleValue } from 'react-select';
import { fetchProjects } from '../../api';
import { Project } from '../../types';
import { mergeSelectStyles } from '../widgets/components/SelectStyles';

interface OptionType {
  value: string;
  label: string;
  project: Project;
}

interface ProjectPickerProps {
  selectedProjectId?: string;
  onProjectChange: (projectId: string | undefined, project?: Project) => void;
  clientId?: string;
  isDisabled?: boolean;
  placeholder?: string;
}

export const ProjectPicker: React.FC<ProjectPickerProps> = ({
  selectedProjectId,
  onProjectChange,
  clientId,
  isDisabled,
  placeholder = 'Select project...'.toTranslatedDisplay(),
}) => {
  const [options, setOptions] = useState<OptionType[]>([]);
  const [selected, setSelected] = useState<SingleValue<OptionType>>(null);

  useEffect(() => {
    fetchProjects('Active', clientId, true)
      .then(projects => {
        const opts = projects.map(p => ({
          value: p.projectId!,
          label: `${p.projectNo} — ${p.name}`,
          project: p,
        }));
        setOptions(opts);

        if (selectedProjectId) {
          const match = opts.find(o => o.value === selectedProjectId);
          setSelected(match ?? null);
        }
      })
      .catch(() => {});
  }, [clientId, selectedProjectId]);

  const handleChange = (opt: SingleValue<OptionType>) => {
    setSelected(opt);
    onProjectChange(opt?.value, opt?.project);
  };

  const handleClear = () => {
    setSelected(null);
    onProjectChange(undefined);
  };

  return (
    <Select<OptionType>
      options={options}
      value={selected}
      onChange={handleChange}
      isDisabled={isDisabled}
      isClearable
      placeholder={placeholder}
      classNamePrefix='react-select'
      noOptionsMessage={() => 'No active projects'.toTranslatedDisplay()}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      styles={mergeSelectStyles()}
    />
  );
};
